import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Footer from '../Footer/Footer';
import HeaderOur from './HeaderOur';
import OurNavbar from './OurNavbar';
import { CheckCircleIcon } from '@heroicons/react/24/solid';

const OurExpertise = () => {
    const navigate = useNavigate();
  
    const handleNavigate = (path: string) => {
      navigate(path);
    };


    const handleGetInTouch = () => {
      // Ha már a főoldalon vagyunk, csak görgessünk
      if (window.location.pathname === "/") {
        const contactSection = document.getElementById("contact");
        if (contactSection) {
          contactSection.scrollIntoView({ behavior: "smooth" });
        }
      } else {
        // Ha nem a főoldalon vagyunk, navigáljunk oda, majd görgessünk
        navigate("/"); // átirányítás a főoldalra
        setTimeout(() => {
          const contactSection = document.getElementById("contact");
          if (contactSection) {
            contactSection.scrollIntoView({ behavior: "smooth" });
          }
        }, 100); // kis késleltetés, hogy betöltődjön az oldal
      }
    };
    useEffect(() => {
      const faders = document.querySelectorAll('.fade-in');
    
      const appearOptions = {
        threshold: 0.2, // kicsit előbb figyel
        rootMargin: "0px 0px -200px 0px" // előbb elkezdi tölteni
      };
    
      const appearOnScroll = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('show');
          observer.unobserve(entry.target);
        });
      }, appearOptions);
    
      faders.forEach((fader, index) => {
        const el = fader as HTMLElement;
        el.style.transitionDelay = `${index * 0.03}s`; // kicsit lassabb chain effekt
        appearOnScroll.observe(el);
      });
    }, []);
  
    return (
    <>
    <OurNavbar />
    <HeaderOur/>
      <section className="services-wrapper-our">
        <h2 className="services-heading-our"></h2>
        <div className="cards-container-our">
          {/* Kártya 1 */}
          <div className="service-card-our">
            <img src='mental.png' alt=' ' className='our-img fade-in'/>
            <div className="card-text-our fade-in">
            Understanding the risk and threat associated with human behaviour is a unique, dynamic and developing area of professional practice in which TAG has leading expertise.  
            TAG comprises expert professionals in a number of chosen disciplines, who have unique experience in the assessment, 
            identification, intervention and management of the risk posed by human behaviour and risk.  
            To this end, the expertise offered by TAG aims to bridge the gap between operational and cyber security and to supplement the traditional work of human resources with this 
            specialist area of forensic practice. Our decades of combined experience across various sectors
            including Government, Academia and Business places our team in a unique position to provide expert services to meet the increasing risk and threats posed by human behaviour. 
            </div>
         </div>
        <div className='hover-section-our fade-in'> 
            <h1 className='h1-h fade-in'>Our Purpose</h1>
            <p className='fade-in'>TAG strives to promote safety and security through human risk identification, assessment, mitigation and management. Through the provision of risk management solutions for diverse threats and complex environments, 
                TAG ensures the protection of people, assets, infrastructure and systems.</p>
        </div>
        <div className='hover-section-our fade-in'> 
            <h1 className='h1-h  fade-in'>Our focus</h1>
            <p className='fade-in'>Our combined experience, skills and knowledge position us to aid in a multifaceted approach to assist with diverse areas of need, allowing a tailored approach to each individual or organisation.  </p>
        </div>
       <div className="hover-section-our fade-in">
  <h1 className="h1-h fade-in">Organisations that need our service</h1>
  <p className="fade-in">
    TAG can work with a range of organisations and services in relation to which human risk 
    and the management thereof is a relevant issue. This includes but is not limited to:
  </p>

  {/* ✅ Két oszlopos check-lista */}
  <div className="services-grid-our">
    {/* Első oszlop */}
    <div>
      <div className="services-item fade-in">
        <CheckCircleIcon className="check-icon" />
        <p className="text-body">Academic institutions</p>
      </div>

      <div className="services-item fade-in">
        <CheckCircleIcon className="check-icon" />
        <p className="text-body">Transport industry (including aviation)</p>
      </div>

      <div className="services-item fade-in">
        <CheckCircleIcon className="check-icon" />
        <p className="text-body">Banks and financial organisations</p>
      </div>

      <div className="services-item fade-in">
        <CheckCircleIcon className="check-icon" />
        <p className="text-body">Corporate entities</p>
      </div>
    </div>

    {/* Második oszlop */}
    <div>
      <div className="services-item fade-in">
        <CheckCircleIcon className="check-icon" />
        <p className="text-body">Hospitals / health care institutions</p>
      </div>

      <div className="services-item fade-in">
        <CheckCircleIcon className="check-icon" />
        <p className="text-body">Religious and faith-based institutions</p>
      </div>

      <div className="services-item fade-in">
        <CheckCircleIcon className="check-icon" />
        <p className="text-body">Social welfare organisations</p>
      </div>

      <div className="services-item fade-in">
        <CheckCircleIcon className="check-icon" />
        <p className="text-body">Local Government</p>
      </div>
    </div>
  </div>
</div>

        </div>
        <div className="footer-question ">
          <h2 className="question-1 fade-in">Need more information?</h2>
          <h2 className="text fade-in">
            Contact us today to find out how we can help
          </h2>
              <button className="button fade-in" onClick={handleGetInTouch}>
          Get in touch
        </button>
        </div>
      </section>     
      <Footer />
      </>
    );
  };
  
  export default OurExpertise;
  